<template>
  <footer class="grid grey-250 font-size-1 grid-columns-2 align-content-center">
    <div><router-link
      :to="{ name: 'dashboard'}"
      active-class="active"><svg-logo :class="'block'"/></router-link></div>
    <p class="align-right m0 mt1">&copy;2017 &ndash; {{ now }} <a
      href="https://louderthanten.com"
      target="_blank">Louder Than Ten Industries Inc.</a></p>
  </footer>
</template>

<script>
import Logo from '../svgs/Logo.vue'
import moment from 'moment'
import Ad from './Ad'

export default {
  components: {
    svgLogo: Logo,
    ad: Ad
  },
  computed: {
    now () {
      return moment().year()
    }
  }
}
</script>

<style scoped>
footer {
  padding: var(--page-margin);
  opacity: 0;
}
@supports(padding: max(0px)) {
  footer {
    padding-left: max(var(--page-margin), env(safe-area-inset-left));
    padding-right: max(var(--page-margin), env(safe-area-inset-right));
  }
}
svg {
  height: calc(var(--line) * 1);
}
@media screen and (min-width: 48em) {
  footer {
    opacity: 1;
  }
}
</style>
